/*eslint quote-props: off*/
const tr = {
  addon: {
    attributes: {
      id: 'ID',
      google_product_id: 'ID na Google Store',
      apple_product_id: 'ID na Apple Store',
      is_active:'Ativo',
      currency:'Moeda',
      price: 'Preço',
      size: 'Usuários permitidos',
      created_at: 'Criado em',
      updated_at: 'Atualizado em',
      type: 'Tipo',
      purchasable: 'Comprável',
      coin: 'Moeda',
      name: 'Título',
      lang: 'Linguagem',
      resources_size: 'Usuários permitidos',
      deleted_at:     'Excluído em',
      partner_id: 'Parceiro vinculado',
      period: 'Período de assinatura'
    },
    extras:{
      create_addon: 'Criar adicional',
      edit_addon: 'Editar adicional',
      show_addon: 'Exibir adicional',
      delete_addon: 'Deletar adicional'
    },
    defSingular: 'Adicional',
    defPlural: 'Adicionais',
    type:{
      emergency: 'Emergência',
      driving: 'Direção Inteligente',
      doctor: 'Médicos',
      doctor_all: 'Médicos Especialistas',
      users: 'Usuários',
      unknown: 'Tipo de pacote não cadastrado',
      placeholder: 'Selecione um tipo',
    },
    period:{
      month: 'Mensal',
      semester: 'Semestral',
      year: 'Anual',
    },
  },
};

export default tr;
